export default function () {
  let banner = null;
  const observeConditions = {};
  const currentSizes = {};
  const unsetItems = {};
  let pendingResizes = {};
  let resizeTimeout = null;

  function getBanner() {
    if (!banner) {
      banner = document.querySelector('.js-beta-banner');
    }
    return banner;
  }

  function getCurrentSize(id) {
    return currentSizes[id] ?? 0;
  }

  function setCssVariable(entries) {
    entries.forEach((entry) => {      
      if (entry?.target?.dataset?.heightVarName) {

        const condition = observeConditions[entry.target.id];
        
        if (!condition || condition()) {
          const resizedHeight = entry.borderBoxSize ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
          setCssVariableToHeight(resizedHeight, entry.target.dataset.heightVarName);
        }
      }
    });
  }

  const observerCallbacks = {};

  function setCssVariableToHeight(resizedHeight, varName) {
    
    const curHeight = Math.ceil(resizedHeight);


    //avoid potential unnecessary style recalc by not setting the variable
    //if it has not actually changed.
    if ((currentSizes[varName] ?? -1) != curHeight) {

      const heightWithUnits = `${curHeight}px`;
      performance.mark(`tr-rs ${varName} ${curHeight}`);
      document.documentElement.style.setProperty(
        `--${varName}`,
        heightWithUnits
      );

      currentSizes[varName] = curHeight;
    }
  }

    function registerResize(id, cb) {
      if (!observerCallbacks[id]) {
        observerCallbacks[id] = [];
      }
      observerCallbacks[id].push(cb);
    }

    function checkPendingResizes() {
      const entries = Object.values(pendingResizes);
      setCssVariable(entries);
      entries.forEach((entry) => {
        if (entry?.target?.id && observerCallbacks[entry?.target?.id]) {
          observerCallbacks[entry?.target?.id].forEach((cb) => {
            cb(entry);
          });
        }
      });

      resizeTimeout = null;
      pendingResizes = {};
    }
    function onResizeBanner(entries) {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      let checkImmediately = false;
      entries.filter((entry) => entry?.target?.id).forEach((entry) => {
        pendingResizes[entry.target.id] = entry;
        if (unsetItems[entry.target.id]) {
          checkImmediately = true;
          delete unsetItems[entry.target.id];
        }
      });
      if (checkImmediately) {
        checkPendingResizes();
      } else {
        setTimeout(checkPendingResizes, 5);
      }
    }

    const bannerResizeObserver = new ResizeObserver(onResizeBanner);
    
    function observeElementHeight(element, condition) {
      if (element && element?.dataset?.heightVarName && element.id) {
        if (condition) {
          observeConditions[element.id] = condition;
        }

        unsetItems[element.id] = true;

        bannerResizeObserver.observe(element, {});

        // //variable will not get set on time now that this is throttled - set it right away.
        // setCssVariableToHeight(element.getBoundingClientRect().height, element.dataset.heightVarName);
      }
    }

    function initBanner() {
      observeElementHeight(getBanner());
    }

  window.cmhrBetaBannerSettings =  {
    getBanner: getBanner,
    setCssVariable: setCssVariable,
    registerResize: registerResize,
    initBanner: initBanner,
    observeElementHeight: observeElementHeight,
    getCurrentSize: getCurrentSize
  }

  return window.cmhrBetaBannerSettings;
}